import {
  Button,
  Divider,
  Drawer,
  Form,
  Input,
  InputRef,
  Select,
  Space,
  Tooltip,
} from "antd";
import { useContext, useEffect, useState, useRef } from "react";
import { IBaseDrawerModel, IDrawerModel, IOrganisationDetails } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import OrganisationsService, {
  IDepartmentOptionsList,
  IDepttData,
  IDesignationData,
  IDesignationOptionsList,
  IDesignationRequestModel,
  ISubUnitData,
  ISubUnitOptionsList,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useHotkey } from "../../Context/HotKeyContext";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import AddOrganisationModel from "./AddOrganisationModel";
import AddSubUnitModel from "./AddSubUnitModel";
import AddDepttModel from "./AddDepttModel";

const AddDesignationModel = ({
  isModalOpen,
  setOpenModel,
  id,
  setTrigger,
  setNewDesignationResponse,
  placement,
  organisationId,
  organisationName,
  subUnitId,
  subUnitName,
  departmentId,
  departmentName,
}: IOrganisationDetails) => {
  const { showKeys } = useHotkey();
  const autoCompleteRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IIdNameModel[]>([]);
  const [subUnitList, setSubUnitList] = useState<ISubUnitOptionsList[]>([]);
  const [depttList, setDepttList] = useState<IDepartmentOptionsList[]>([]);
  const [selOrg, setSelOrg] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [selSubUnit, setSelSubUnit] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [allDesignations, setAllDesignations] = useState<string[]>([]);
  const [duplicateData, setDuplicateData] = useState<boolean>(false);
  const [newOrganisationResponse, setNewOrganisationResponse] =
    useState<IIdNameModel>({ id: "", name: "" });
  const [addOpenModel, setAddOpenModel] = useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [newSubUnitResponse, setNewSubUnitResponse] =
    useState<ISubUnitOptionsList>({ id: "", name: "", orgId: "" });
  const [newDepartmentResponse, setNewDepartmentResponse] =
    useState<IDepartmentOptionsList>({ id: "", name: "", subUnitId: "" });
  // Post Api
  const saveData = () => {
    setLoading(true);
    form.validateFields().then(async (val) => {
      let newVal = {
        ...val,
        designationName: val.designationName.trim(),
        orgId: val.orgId?.value,
        subUnitId: val.subUnitId?.value,
        depttId: val.depttId?.value,
      };

      await OrganisationsService.postDesignation(
        currentClient?.id!,
        newVal,
        id!
      )
        .then((val: IApiResponse<IIdNameModel>) => {
          if (val.result) {
            openNotification(
              "success",
              `${val?.result?.name} designation ${
                id ? "updated" : "added"
              } successfully`
            );
            setOpenModel({
              type: "",
              param: {},
            });
            setNewDesignationResponse &&
              setNewDesignationResponse({
                ...val.result,
                depttId: departmentId!,
              });
            setLoading(false);
            setTrigger && setTrigger((prev) => !prev);
          } else {
            setLoading(false);
            openNotification("error", val.message);
          }
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    });
  };
  // if (organisationId && subUnitId && departmentId) {
  //   form.setFieldValue("orgId", organisationId);
  //   form.setFieldValue("subUnitId", subUnitId);
  //   form.setFieldValue("depttId", departmentId);
  // }
  // // useEffect(() => {
  // //   if (organisationId !== undefined && subUnitId !== undefined) {
  // //     setSelOrg(organisationId);
  // //     setSelSubUnit(subUnitId);
  // //   }
  // // }, [subUnitId]);

  useEffect(() => {
    (async () => {
      await OrganisationsService.getDesignationOptionsList(
        currentClient?.id!
      ).then((data: IDesignationOptionsList[] | null) => {
        setAllDesignations(
          data!.map((each: IDesignationOptionsList) => each.name)
        );
      });
    })();
  }, []);

  //----- adding new  organisation data  ----------//
  useEffect(() => {
    if (newOrganisationResponse.id.length > 0) {
      setOrgList((pre: IIdNameModel[]) => {
        let newData = [...pre, newOrganisationResponse];
        return newData;
      });
    }
  }, [newOrganisationResponse]);

  //----- newly added organisation data placed in form ----------//
  useEffect(() => {
    let exist = orgList.some(
      (e: IIdNameModel) => e.id === newOrganisationResponse.id
    );
    if (exist) {
      form.setFieldValue("orgId", {
        key: newOrganisationResponse.id,
        value: newOrganisationResponse.id,
        label: newOrganisationResponse.name,
        title: "",
      });
      setSelOrg({
        id: newOrganisationResponse?.id,
        name: newOrganisationResponse.name,
      });
      form.setFieldValue("subUnitId", undefined);
      setSelSubUnit({ id: "", name: "" });
    }
  }, [orgList]);

  //----- adding new  SubUnit  data  ----------//
  useEffect(() => {
    if (newSubUnitResponse.id.length > 0) {
      setSubUnitList((pre: ISubUnitOptionsList[]) => {
        let newData = [...pre, newSubUnitResponse];
        return newData;
      });
    }
  }, [newSubUnitResponse]);

  //----- newly added sub unit data  placing in form ----------//
  useEffect(() => {
    console.log("newSubUnitResponse", newSubUnitResponse);
    let exist = subUnitList.some(
      (e: ISubUnitOptionsList) => e.id === newSubUnitResponse.id
    );
    if (exist) {
      form.setFieldValue("subUnitId", {
        key: newSubUnitResponse.id,
        value: newSubUnitResponse.id,
        label: newSubUnitResponse.name,
        title: "",
      });
      setSelSubUnit({
        id: newSubUnitResponse.id,
        name: newSubUnitResponse.name,
      });
      form.setFieldValue("depttId", undefined);
    }
  }, [subUnitList]);

  //----- adding new  Department data  ----------//
  useEffect(() => {
    if (newDepartmentResponse?.id.length > 0) {
      setDepttList((pre: IDepartmentOptionsList[]) => {
        let newData = [...pre, newDepartmentResponse];
        return newData;
      });
    }
  }, [newDepartmentResponse]);

  //----- newly added Department data  placing in form ----------//
  useEffect(() => {
    let exist = depttList.some(
      (e: IDepartmentOptionsList) => e.id === newDepartmentResponse.id
    );
    if (exist)
      form.setFieldValue("depttId", {
        key: newDepartmentResponse.id,
        value: newDepartmentResponse.id,
        label: newDepartmentResponse.name,
        title: "",
      });
  }, [depttList]);

  const getData = async () => {
    setLoading(true);

    await OrganisationsService.getDesignation(currentClient?.id!, id!)
      .then((val: IDesignationRequestModel | null) => {
        setSelOrg({ id: val?.orgId!, name: val?.orgName! });
        setSelSubUnit({ id: val?.subUnitId!, name: val?.subUnitName! });
        let formValues = {
          designationName: val?.designationName,
          parentDesignationId: val?.parentDesignationId,
          orgId: { value: val?.orgId, label: val?.orgName },
          subUnitId: { value: val?.subUnitId, label: val?.subUnitName },
          depttId: { value: val?.depttId, label: val?.depttName },
        };

        form.setFieldsValue(formValues);
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  console.log("subUnitKey", form.getFieldValue("subUnitId")?.key);
  useEffect(() => {
    if (id) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getOrgList = async () => {
    debugger;
    if (organisationId && organisationName) {
      form.setFieldValue("orgId", {
        key: organisationId,
        value: organisationId,
        label: organisationName,
        title: "",
      });
      setSelOrg({ id: organisationId, name: organisationName });
    } else {
      setLoading(true);
      await OrganisationsService.getOrgOptionsList(currentClient?.id!)
        .then((val) => {
          if (val) {
            setOrgList(val);
          }
          setLoading(false);
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    }
  };

  const getSubUnitList = async () => {
    if (subUnitId && subUnitName) {
      form.setFieldValue("subUnitId", {
        key: subUnitId,
        value: subUnitId,
        label: subUnitName,
        title: "",
      });
      setSelSubUnit({ id: subUnitId, name: subUnitName });
    } else {
      setLoading(true);
      await OrganisationsService.getSubUnitOptionsList(currentClient?.id!)
        .then((val) => {
          if (val) {
            setSubUnitList(val);
          }
          setLoading(false);
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    }
  };

  const handleDuplicates = (desgName: string) => {
    let filteredData = allDesignations.filter(
      (e) => e.toLowerCase().trim() === desgName.toLowerCase().trim()
    );
    if (filteredData.length > 0) setDuplicateData(true);
    else setDuplicateData(false);
  };

  const getDepttList = async () => {
    if (departmentId && departmentName) {
      form.setFieldValue("depttId", {
        key: departmentId,
        value: departmentId,
        label: departmentName,
        title: "",
      });
    } else {
      setLoading(true);
      await OrganisationsService.getDepartmentOptionsList(currentClient?.id!)
        .then((val: IDepartmentOptionsList[] | null) => {
          if (val) {
            setDepttList(val);
          }
          setLoading(false);
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getOrgList();
    getSubUnitList();
    getDepttList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  useEffect(() => {
    if (orgList.length > 0) {
      const timer = setTimeout(() => {
        if (autoCompleteRef.current) {
          autoCompleteRef.current.focus();
        }
      }, 100); // Adjust delay if needed

      return () => clearTimeout(timer);
    }
  }, [orgList]); // Ensures autofocus after initial render

  EntryLevelKeys({
    save: () => saveData(),

    cancel: () =>
      setOpenModel({
        type: "",
        param: {},
      }),
  });

  return (
    <>
      <Drawer
        open={isModalOpen}
        onClose={() =>
          setOpenModel({
            type: "",
            param: {},
          })
        }
        title={`${id ? "Update" : "Add"} designation`}
        placement={placement ?? "right"}
        width={"500px"}
        closable={false}
        maskClosable={false}
        extra={
          <Space>
            <CloseOutlined
              onClick={() =>
                setOpenModel({
                  type: "",
                  param: {},
                })
              }
            />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Space>
              <Tooltip
                title={<p>ALT+C</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  onClick={() => {
                    form.resetFields();
                    setOpenModel({
                      type: "",
                      param: {},
                    });
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>

              <Tooltip
                title={<p>ALT+S</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  loading={loading}
                  type="primary"
                  onClick={() => saveData()}
                >
                  {`${id ? "Update" : "Save"}`}
                </Button>
              </Tooltip>
            </Space>
          </div>
        }
      >
        <Form
          name="designation"
          form={form}
          disabled={loading}
          layout="vertical"
        >
          <Form.Item
            name="designationName"
            label="Designation's Name"
            rules={[
              { required: true },
              {
                pattern:
                  /^(?!.* {2})([A-Za-z][A-Za-z0-9_()&\-., ]{1,48}[A-Za-z0-9])$/,
                message: "Value's length must be between 3 and 50",
              },
              {
                validator: () => {
                  if (duplicateData)
                    return Promise.reject("Designation Name already exist");
                  else return Promise.resolve();
                },
              },
            ]}
            className="input-item"
          >
            <Input
              type="text"
              maxLength={50}
              minLength={3}
              ref={autoCompleteRef}
              placeholder="Enter name here..."
              onChange={(e) => handleDuplicates(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="orgId"
            label="Organisation"
            rules={[{ required: true, message: "Please select organisation" }]}
            className="mb-14"
          >
            <Select
              labelInValue
              placeholder="Select organisation"
              onChange={(val) => {
                form.setFieldValue("subUnitId", undefined);
                form.setFieldValue("depttId", undefined);
                setSelOrg({ id: val?.value, name: val?.label });
                setSelSubUnit({ id: "", name: "" });
              }}
              options={orgList?.map((org: IIdNameModel) => ({
                label: org.name,
                value: org.id,
                key: org.id,
                title: "",
              }))}
              disabled={organisationId ? true : false}
              dropdownRender={(orgList) => (
                <>
                  {orgList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "Organisation",
                        param: {},
                      })
                    }
                  >
                    New Organisation
                  </Button>
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            name="subUnitId"
            label="Sub Unit"
            rules={[{ required: true, message: "Please select sub unit" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selOrg.id === "" || subUnitId !== undefined}
              placeholder="Select sub unit"
              onChange={(val) => {
                form.setFieldValue("depttId", undefined);
                setSelSubUnit({ id: val?.value, name: val?.label });
                console.log("subUnitId", subUnitId);
              }}
              options={subUnitList
                .filter(
                  (subUnit: ISubUnitOptionsList) => subUnit.orgId === selOrg.id
                )
                .map((subUnit: ISubUnitOptionsList) => ({
                  label: subUnit.name,
                  value: subUnit.id,
                  key: subUnit.id,
                  title: "",
                }))}
              dropdownRender={(subUnitList) => (
                <>
                  {subUnitList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "SubUnit",
                        param: {},
                      })
                    }
                  >
                    New Sub Unit
                  </Button>
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            name="depttId"
            label="Department"
            rules={[{ required: true, message: "Please select department" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selSubUnit.id === "" || departmentId !== undefined}
              placeholder="Select department"
              options={depttList
                .filter(
                  (deptt: IDepartmentOptionsList) =>
                    deptt?.subUnitId === selSubUnit.id
                )
                .map((deptt: IDepartmentOptionsList) => ({
                  label: deptt.name,
                  value: deptt.id,
                  key: deptt.id,
                  title: "",
                }))}
              dropdownRender={(depttList) => (
                <>
                  {depttList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "New Department",
                        param: {},
                      })
                    }
                  >
                    New Department
                  </Button>
                </>
              )}
            />
          </Form.Item>
        </Form>
      </Drawer>
      {addOpenModel.type === "Organisation" && (
        <AddOrganisationModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewResponse={setNewOrganisationResponse}
          placement={"left"}
        />
      )}
      {addOpenModel.type === "SubUnit" && (
        <AddSubUnitModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewSubUnitResponse={setNewSubUnitResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
        />
      )}
      {addOpenModel.type === "New Department" && (
        <AddDepttModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewDepartmentResponse={setNewDepartmentResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
          subUnitId={selSubUnit.id}
          subUnitName={selSubUnit.name}
        />
      )}
    </>
  );
};

export default AddDesignationModel;
